var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBirthday(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u751F\u65E5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5B8C\\u5584\\u4FE1\\u606F\\u9875",
    transform: "translate(-51, -930)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u751F\\u65E5",
    transform: "translate(51, 930)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    stroke: "#979797",
    fill: "#D8D8D8",
    opacity: 0,
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5,6.00000001 C15.0522847,6.00000001 15.5,6.3581722 15.5,6.8 L15.5,10 L20.6470588,10 C22.4349827,10 23.8960546,11.3773233 23.9946923,13.1127388 L24,13.3 L24,18.8 C24,18.8675777 23.9969042,18.9344438 23.9908446,19.0004683 L25.5,19 C27.4329966,19 29,20.4774603 29,22.3 L29,27.8 C29,29.0150264 27.9553311,30 26.6666667,30 L3.33333334,30 C2.04466892,30 1,29.0150264 1,27.8 L1,22.3 C1,20.4774603 2.56700338,19 4.5,19 L5.00915541,19.0004683 C5.00309579,18.9344438 5,18.8675777 5,18.8 L5,13.3 C5,11.4774603 6.5011629,10 8.35294118,10 L13.5,10 L13.5,6.8 C13.5,6.3581722 13.9477153,6.00000001 14.5,6.00000001 Z M25.5,21.2 L4.5,21.2 C4.19058076,21.2 3.89383452,21.3158925 3.67504208,21.5221825 C3.45624964,21.7284726 3.33333334,22.0082619 3.33333334,22.3 L3.33333334,27.8 L26.6666667,27.8 L26.6666667,22.3 C26.6666667,22.0082619 26.5437504,21.7284726 26.3249579,21.5221825 C26.1061655,21.3158925 25.8094192,21.2 25.5,21.2 Z M20.6470588,12.2 L8.35294118,12.2 C8.05652275,12.2 7.77224484,12.3158925 7.56264535,12.5221825 C7.35304586,12.7284726 7.2352941,13.0082619 7.2352941,13.3 L7.2352941,18.8 L21.7647059,18.8 L21.7647059,13.3 C21.7647059,13.0082619 21.6469541,12.7284726 21.4373546,12.5221825 C21.2277552,12.3158925 20.9434773,12.2 20.6470588,12.2 Z M14.5,0 C15.5,1.50419999 16,2.58779999 16,3.25020002 C16,4.24431254 15.3284271,5.05019994 14.5,5.05019994 C13.6715729,5.05019994 13,4.24431254 13,3.25020002 C13,2.58780002 13.5,1.50420002 14.5,0 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    fill: "#111111",
    fillRule: "nonzero"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirthday);
export default __webpack_public_path__ + "static/media/birthday.086f45d299e37117852eadaf170c4383.svg";
export { ForwardRef as ReactComponent };